import { SIZE_50 } from '@/lib/gridElements/size';

import { ChoroplethMapChart } from '@/components/composite/Charts/ChoroplethMapChart';

export const countriesDistributionConfig = {
    title: 'chart.instagram.countries_distribution',
    height: 300,
    name: {
        name: 'chart.instagram.countries_distribution_country',
        value: 'chart.instagram.countries_distribution_value',
        country: 'chart.instagram.countries_distribution_country',
        percentage: 'percentage'
    },
    defaultTableSorting: [{ id: 'value', desc: true }],
    tooltip: 'chart.instagram.countries_distribution_tooltip',
    noLegend: true,
    datePickerDoesNotApply: true,
    id: 'countries_distribution',
    size: SIZE_50,
    type: 'chart',
    element: ChoroplethMapChart
};
